import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormsService } from '../../providers/forms.service';
import { ScrollService } from '../../providers/scroll.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from '../../providers/firebase.service';
import { LocationInfo } from "../../models/locationInfo";
import { Client } from "../../models/client";
import { isNullOrUndefined } from 'util';
import 'rxjs/add/operator/first';
import { PortableInfo } from 'ng2/app/models/portableInfo';

@Component({
  selector: 'app-portable-settings',
  templateUrl: './portable-settings.component.html',
  styleUrls: ['./portable-settings.component.css']
})
export class PortableSettingsComponent implements OnInit, AfterViewInit {
  key: string;
  locKey: string;
  path: string;
  showLoading = true;
  hideGetChargesButton = false;
  clientData: Client;
  locations: LocationInfo[];
  options: any[];
  storeAtOptions = [
    { label: 'At Facility', value: 'facility' },
    { label: 'On Site', value: 'onSite' }
  ];
  quoteTypeOptions = [
    { label: 'Storage', value: 'storage' },
    { label: 'Local Move', value: 'localMove' },
    { label: 'Moving and Storage', value: 'movingAndStorage' }
  ];

  constructor(
    public forms: FormsService,
    public route: ActivatedRoute,
    public afService: FirebaseService,
    private scroll: ScrollService,
    public router: Router,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.locKey = params['locKey'];
      this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;
        if (isNullOrUndefined(this.clientData.portableInfo)) {
          this.clientData.portableInfo = new PortableInfo();
          this.updateClient();
        }
        // make sure an array actually exists
        if (isNullOrUndefined(this.clientData.portableInfo.locations)) {
          this.clientData.portableInfo.locations = [];
        }
        if (isNullOrUndefined(this.clientData.portableInfo.disableDays)) {
          this.clientData.portableInfo.disableDays = [false, false, false, false, false, false, false];
        }
        this.afService.getLocations(this.clientData).subscribe((locations) => {
          this.locations = locations;
          // for the location dropdown
          this.options = [];
          for (let location of locations) {
            this.options.push({ label: location.name, value: location.$key });
          }
          this.showLoading = false;
        });
      });
    });
  }

  ngAfterViewInit() {
    this.scroll.scrollToTop();
  }

  updateClient() {
    this.afService.updateClient(this.clientData).then((data) => {
      this.afService.openSnackBar('Client portable settings successfully saved.');
    });
  }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/portable-settings/portable-settings.component.ts